module.exports = __webpack_public_path__ + "img/sapphire.be5030ca.webp";